import { render, staticRenderFns } from "./app.vue?vue&type=template&id=6fb8108a&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8108a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb8108a')) {
      api.createRecord('6fb8108a', component.options)
    } else {
      api.reload('6fb8108a', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=6fb8108a&scoped=true&", function () {
      api.rerender('6fb8108a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app.vue"
export default component.exports